import React from "react";
import "../../pages/FlowChat/Home.css"

const Avatar = ({ children, bg, className }) => {
  return (
    <div id="avatar" style={{ backgroundColor: `${bg}` }}>
      <div className={className}>{children}</div>
    </div>
  );
};

export default Avatar;
